import React from 'react'

import OfferVehicleDetails from './OfferVehicleDetails'
import DoneModal from '../generic/modals/DoneModal'

import { ModalContentNormal } from '../generic/Basics.js'
export default ({ setShowModal, vehicleInfo, isAdmin }) => {
  return (
    <DoneModal name={'vehicleDetails'} title={'Offer Details'} subtitle={"Please review the information you've given us."} onClick={e => setShowModal(false)} informational={true}>
      <ModalContentNormal>
        <OfferVehicleDetails showContact={true} vehicleInfo={vehicleInfo} isAdmin={isAdmin} />
      </ModalContentNormal>
    </DoneModal>
  )
}
